module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iapp"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "iapp-content"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('user_center_iapp_title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('user_center_iapp_tip')))]), _vm._v(" "), _c('div', {
    staticClass: "iapp-download"
  }, [_c('div', {
    staticClass: "iapp-qrcode"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/xiaochengxu.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('mini_program')))])]), _vm._v(" "), _c('div', {
    staticClass: "iapp-qrcode"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/iapp.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('user_center_iapp_qrcode')))])]), _vm._v(" "), _vm._m(1, false, false)])]), _vm._v(" "), _vm._m(2, false, false)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iapp-title"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/app_icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v("iAPP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iapp-phone"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/iapp-best-travel-companion/id1210741206?mt=8"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/iOS.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/android"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/Android.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iapp-banner"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/download_inset.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a8effa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/iAPP.vue
// module id = 812
// module chunks = 0